
export const ANALYTICS = {
  IS__MOENGAGE_ENABLED: process.env.NEXT_PUBLIC_MOENGAGE_ENABLED === 'true',
  IS__VWO_ENABLED: process.env.NEXT_PUBLIC_VWO_ENABLED === 'true',
};

export const VWO = {
  ACCOUNT_ID: process.env.NEXT_PUBLIC_VWO_ACCOUNT_ID || '1012498',
  BASE_URL:
    process.env.NEXT_PUBLIC_VWO_BASE_URL ||
    'https://dev.visualwebsiteoptimizer.com',
};
